__turbopack_context__.v({
  "cancellation_cover_wrapper": "_5tMaxG_cancellation_cover_wrapper",
  "droplistBox": "_5tMaxG_droplistBox",
  "modal_button": "_5tMaxG_modal_button",
});
